import { formatMoney, showDate, toDate, type Money } from '@trippath/shared';

/** `18 Oct 2026` from `2026-10-18`; the ISO text itself if it is not a date. */
export function day(iso: string, language: string): string {
  const date = toDate(iso);
  return date ? showDate(date, language) : iso;
}

/** `18 Oct` from `2026-10-18`: a day of the trip, the year understood. */
export function dayShort(iso: string, language: string): string {
  return new Intl.DateTimeFormat(language === 'et' ? 'et-EE' : 'en-GB', {
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC',
  }).format(new Date(`${iso}T00:00:00Z`));
}

/** `35.65 %` from basis points, in the UI language. */
export function percent(basisPoints: number, language: string): string {
  return new Intl.NumberFormat(language === 'et' ? 'et-EE' : 'en-GB', {
    style: 'percent',
    maximumFractionDigits: 1,
  }).format(basisPoints / 10_000);
}

/** The words for a problem code from the server, falling back to the generic one. */
export function problemKey(code: string): string {
  const known = [
    'required',
    'too_long',
    'format',
    'range',
    'reversed',
    'negative',
    'mismatch',
    'taken',
    'no_rate',
    'gone',
    'booked',
    'leaked',
    'archived',
  ];
  return `problem.${known.includes(code) ? code : 'format'}`;
}

/**
 * A price in the money it is paid in, with what the plan counts beside it — `THB 1,900 ≈ €50` —
 * or the plan's alone when it was paid in the trip's own.
 */
export function priceSaid(price: Money, paid: Money | null, language: string): string {
  return paid
    ? `${formatMoney(paid, language)} ≈ ${formatMoney(price, language)}`
    : formatMoney(price, language);
}
